import { render, staticRenderFns } from "./webinarsRecording.vue?vue&type=template&id=4719e648&"
import script from "./webinarsRecording.vue?vue&type=script&lang=js&"
export * from "./webinarsRecording.vue?vue&type=script&lang=js&"
import style0 from "./webinarsRecording.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports